import axios from 'axios';
import { store } from '../../js/store';


const axiosInstance = axios.create({
  baseURL: process.env.API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const token = store.getters.getToken;
if (token) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}

let numLoadings = 0;
const requestHandler = (request) => {
  numLoadings++;
  // store.dispatch('setCargando', true);
  return request;
};
const responseHandler = (response) => {
  if ((--numLoadings) === 0) {
    // store.dispatch('setCargando', false);
  }
  return response;
};
const errorHandler = (error) => {
  const mensaje = {
    data: {
      message: error.response.data.message,
    },
    status: 500,
  };
    // store.dispatch("cambiarEstadoModal", true);
    // store.dispatch("cambiarMensajeModal", mensaje);
  if (!(--numLoadings)) {
    // store.dispatch('setCargando', false);
  }
  return error.response;
};

axiosInstance.interceptors.request.use(request => requestHandler(request));
axiosInstance.interceptors.response.use(
  response => responseHandler(response),
  error => errorHandler(error),
);

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/apiService/config/axios.js